import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const lineAddNewIdSlice = createSlice({
  name: 'lineAddNewId',
  initialState: { lineAddNewId: initialState },
  reducers: {
    lineAddNewIdApi: (state, data) => {
      state.lineAddNewId = data.payload;
    },
  },
});

export const { lineAddNewIdApi } = lineAddNewIdSlice.actions;

export default lineAddNewIdSlice.reducer;
